import { Promotion } from '@api';
import debounce from 'debounce-promise';
import * as React from 'react';
import { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';
import { ChechoutRedeemVoucher } from 'src/js/model/checkout/RedeemVoucher';
import { IshState } from 'src/js/services/IshState';
import { Tabs } from '../containers/payment/reducers/State';
import { AmountState } from '../reducers/State';
import AddCodeComp from './AddCodeComp';

interface Props {
  amount: AmountState;
  onAddCode: (code: string) => void;
  promotions: Promotion[];
  redeemVouchers?: ChechoutRedeemVoucher[];
  redeemedVoucherProducts?: ChechoutRedeemVoucher[];
  onUpdatePayNow?: (val, validate?: boolean) => void;
  onToggleVoucher?: (redeemVoucher, enabled) => void;
  onToggleVoucherProduct?: (redeemVoucher, enabled) => void;
  currentTab?: Tabs;
}

class AmountComp extends React.Component<Props> {
  handleChange = debounce((value): Promise<any> => {
    const { onUpdatePayNow } = this.props;

    const payNowVal = parseFloat(value);

    if (onUpdatePayNow && !isNaN(payNowVal) && payNowVal >= 0) {
      onUpdatePayNow(payNowVal.toFixed(2), true);
    }

    return Promise.resolve();
  }, 500);

  render(): React.ReactElement {
    const {
      amount, onAddCode, promotions, redeemVouchers, redeemedVoucherProducts, onToggleVoucherProduct, onToggleVoucher, currentTab
    } = this.props;
    const activeVoucherWithPayer = redeemVouchers?.find((v) => v.payer);

    const voucherProductsPaymentsMerged = [];

    amount?.voucherPayments?.forEach((vp) => {
      if (vp.redeemVoucherProductId) {
        const added = voucherProductsPaymentsMerged.find((av) => av.redeemVoucherProductId === vp.redeemVoucherProductId);
        added ? added.amount += vp.amount : voucherProductsPaymentsMerged.push({ ...vp });
      }
    });

    return (
      <>
        <AddCodeComp onAdd={onAddCode} promotions={promotions} />
        <div className="col-24 col-xs-24 col-sm-12 amount-content text-right">
          {amount && (amount.subTotal || amount.subTotal === 0) && <Total total={amount.subTotal} />}
          {amount && amount.discount !== 0 && <Discount discount={amount.discount} />}

          {amount && redeemVouchers
            && redeemVouchers.map((v) => (
              <RedeemVoucherComp
                key={v.id}
                redeemVoucher={v}
                voucherPayment={amount?.voucherPayments?.find(
                  (vp) => vp.redeemVoucherId === v.id,
                )}
                disabled={!!(activeVoucherWithPayer && activeVoucherWithPayer.id !== v.id)}
                onChange={onToggleVoucher}
              />
            ))}

          {amount && redeemedVoucherProducts
            && redeemedVoucherProducts.map((v) => (
              <RedeemVoucherComp
                key={v.id}
                redeemVoucher={v}
                voucherPayment={voucherProductsPaymentsMerged.find(
                  (vp) => vp.redeemVoucherProductId === v.id,
                )}
                onChange={onToggleVoucherProduct}
              />
            ))}

          {(amount && currentTab !== Tabs.corporatePass) && amount.credit !== 0 && <Credit credit={amount.credit} /> }

          {(amount && currentTab !== Tabs.corporatePass)
            && ((amount.voucherPayments && amount.voucherPayments.length !== 0) || amount.credit !== 0)
            && amount.ccPayment !== 0 && <CCPayment credit={amount.ccPayment} /> }

          {(amount && currentTab !== Tabs.corporatePass)
            && (amount.payNow || amount.payNow === 0) && amount.payNowVisibility
            && (
              <PayNow
                amount={amount}
                onChange={amount.isEditable ? this.handleChange : null}
              />
            )}
        </div>
      </>
    );
  }
}

const Total = (props) => {
  const currencySymbol = useSelector<IshState, string>(state => state.preferences.location.currency.shortCurrencySymbol)

  return <div className="row total-amount">
    <label className="col-18 col-xs-18">Total</label>
    <span className="col-6 col-xs-6">
      {currencySymbol}
      {parseFloat(props.total).toFixed(2)}
      </span>
  </div>
};

const Discount = (props) => {
  const currencySymbol = useSelector<IshState, string>(state => state.preferences.location.currency.shortCurrencySymbol)

  return <div className="row total-discount">
    <label className="col-18 col-xs-18">Discount</label>
    <span className="col-6 col-xs-6">
      {currencySymbol}
      {parseFloat(props.discount).toFixed(2)}
    </span>
  </div>
};

const Credit = (props) => {
  const currencySymbol = useSelector<IshState, string>(state => state.preferences.location.currency.shortCurrencySymbol)

  return <div className="row total-credit">
    <label className="col-18 col-xs-18">Previous credit</label>
    <span className="col-6 col-xs-6">
      {currencySymbol}
      {parseFloat(props.credit).toFixed(2)}
    </span>
  </div>
};

const CCPayment = (props) => {
  const currencySymbol = useSelector<IshState, string>(state => state.preferences.location.currency.shortCurrencySymbol)

  return <div className="row total-cc">
    <label className="col-18 col-xs-18">Credit Card Amount</label>
    <span className="col-6 col-xs-6">
      {currencySymbol}
      {parseFloat(props.credit).toFixed(2)}
    </span>
  </div>
};

const RedeemVoucherComp = (props) => {
  const {
    redeemVoucher, voucherPayment, onChange, disabled
  } = props;

  const currencySymbol = useSelector<IshState, string>(state => state.preferences.location.currency.shortCurrencySymbol)

  return (
    <div className="row checkout-redeem-voucher">
      <label className="col-18 col-xs-18" htmlFor="">
        <input
          type="checkbox"
          value="true"
          onChange={(e) => onChange(redeemVoucher, e.target.checked)}
          checked={redeemVoucher.enabled}
          disabled={disabled}
        />
        {redeemVoucher.name}
      </label>
      <span className="col-6 col-xs-6">
        {currencySymbol}
        {redeemVoucher.enabled ? (voucherPayment && voucherPayment.amount) || 0 : 0}
      </span>
    </div>
  );
};

const PayNow = ({ amount, onChange }) => {
  const currencySymbol = useSelector<IshState, string>(state => state.preferences.location.currency.shortCurrencySymbol)
  const [payNowVal, setPayNowVal] = useState(amount.payNow);

  useEffect(() => {
    setPayNowVal(amount.payNow)
  }, [amount])

  const paynowInput = <span className="col-6 col-xs-6">
    <NumberFormat
      type="text"
      name="priceValue"
      value={payNowVal}
      onValueChange={values => setPayNowVal(values.floatValue)}
      onBlur={() => {
        onChange(payNowVal)
      }}
      prefix={`${currencySymbol} `}
      decimalScale={2}
      allowNegative={false}
      fixedDecimalScale
      thousandSeparator
    />
  </span>

  const payNowValue = <span className="col-6 col-xs-6">
    {currencySymbol}
    {parseFloat(amount.payNow).toFixed(2)}
  </span>;

  return (
    <div className="row grand-total">
      <label className="col-18 col-xs-18">Pay Now</label>
      {onChange ? paynowInput : payNowValue}
    </div>
  );
};

export default AmountComp;
